import React from 'react';
import Trigger from './Trigger';
import { Wrapper, Bubble } from './bubbleStyles';
import LoginWorkflow from '../LoginWorkflow';
import { Toggle } from 'core/hoc';

// Since the login form is rendered, but initially hidden
// Trigger the `loginIntent` event manually when form is shown
const beforeToggleOn = (cb, ...args) => {
	const evt = new CustomEvent('loginIntent');
	window.dispatchEvent(evt);
	cb(...args);
};

const LoginBubble = (props) => (
	<Toggle>
		{({ on, toggle, wrapper }) => (
			<Wrapper>
				<Trigger onClick={!on ? (e) => beforeToggleOn(toggle, e) : toggle} />

				{on && (
					<Bubble id="loginBubbleCreateAccount" hidden={!on} ref={wrapper}>
						<LoginWorkflow {...props} intentOnMount={false} />
					</Bubble>
				)}
			</Wrapper>
		)}
	</Toggle>
);

export default LoginBubble;
